var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueGooglePlaces',{attrs:{"api-key":_vm.apiKey,"enable-geolocation":true},on:{"placechanged":function($event){return _vm.$emit('update', $event)}}},[_c('v-text-field',_vm._g(_vm._b({model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }